module.exports = __webpack_public_path__ + "media/components/theme/fonts/CooperHewitt-Bold-27b39abc002bbce7e8b1de468b9f27cd.woff2";